import { IAutoAuthFailureCause } from "@/store/slices/app/types"

export const TELEGRAM_AUTH_ERROR_MESSAGE_KEYS = {
  reopen: "auth.telegramErrors.reopen",
  temporary: "auth.telegramErrors.temporary"
} as const

type ITelegramAuthErrorMessageKey =
  (typeof TELEGRAM_AUTH_ERROR_MESSAGE_KEYS)[keyof typeof TELEGRAM_AUTH_ERROR_MESSAGE_KEYS]

export const telegramAuthErrorMessageKey = (
  cause: IAutoAuthFailureCause
): ITelegramAuthErrorMessageKey =>
  cause === "transient"
    ? TELEGRAM_AUTH_ERROR_MESSAGE_KEYS.temporary
    : TELEGRAM_AUTH_ERROR_MESSAGE_KEYS.reopen

export type ITelegramAuthErrorAction = "retry" | "close"

export const TELEGRAM_AUTH_ERROR_ACTION_KEYS = {
  retry: "buttons.retry",
  close: "buttons.close"
} as const

export const telegramAuthErrorAction = (
  cause: IAutoAuthFailureCause
): ITelegramAuthErrorAction => (cause === "transient" ? "retry" : "close")
